// src/context/ReactDevTools.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ReactDevTools = createContext();

export const useReactDevTools = () => {
  const context = useContext(ReactDevTools);
  if (!context) {
    throw new Error('useReactDevTools must be used within ReactDevToolsProvider');
  }
  return context;
};

export const ReactDevToolsProvider = ({ children }) => {
  const [isSecretMode, setIsSecretMode] = useState(false); // Always start with false
  const [secretFeatures, setSecretFeatures] = useState({
    showDevTools: false,
    showDebugInfo: false,
    showAdminActions: false,
    showPerformanceMetrics: false,
    showSecretMenu: false,
  });

  // Remove the localStorage check - always start with secret mode disabled
  // useEffect(() => {
  //   const savedMode = localStorage.getItem('dev-tools-mode');
  //   if (savedMode) {
  //     setIsSecretMode(savedMode === 'true');
  //   }
  // }, []);

  const toggleSecretMode = useCallback(() => {
    setIsSecretMode(prev => {
      const newMode = !prev;
      // Remove localStorage persistence
      // localStorage.setItem('dev-tools-mode', String(newMode));
      return newMode;
    });
  }, []);

  // ONLY Ctrl+Shift+X shortcut
  useEffect(() => {
    const handleKeyDown = (event) => {
      const isCtrl = event.ctrlKey || event.metaKey;
      const isShift = event.shiftKey;
      const isX = event.key === 'x' || event.key === 'X';

      if (isCtrl && isShift && isX) {
        event.preventDefault();
        toggleSecretMode();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggleSecretMode]);

  const toggleFeature = useCallback((featureName) => {
    setSecretFeatures(prev => ({
      ...prev,
      [featureName]: !prev[featureName]
    }));
  }, []);

  const enableSecretMode = useCallback(() => {
    setIsSecretMode(true);
    // Remove localStorage persistence
    // localStorage.setItem('dev-tools-mode', 'true');
  }, []);

  const disableSecretMode = useCallback(() => {
    setIsSecretMode(false);
    // Remove localStorage persistence
    // localStorage.setItem('dev-tools-mode', 'false');
    // Reset all features
    setSecretFeatures({
      showDevTools: false,
      showDebugInfo: false,
      showAdminActions: false,
      showPerformanceMetrics: false,
      showSecretMenu: false,
    });
  }, []);

  const value = {
    isSecretMode,
    secretFeatures,
    toggleSecretMode,
    toggleFeature,
    enableSecretMode,
    disableSecretMode,
  };

  return (
    <ReactDevTools.Provider value={value}>
      {children}
    </ReactDevTools.Provider>
  );
};